import routeName from '../constant';

const routes = [{
    path: 'benefi-bank-acc',
    name: routeName.BENE_FI_BANK_ACC,
    component: () => import('@/views/aplCatl640and631/B6/landingPage/Index.vue'),
    meta: { auth: true, code: 'B6', metaTitle: '受益人匯款帳號約定/變更', leaveAlert: true, unableBack: true },
}];

export default routes;
